module.exports = __webpack_public_path__ + "static/media/branding.84aaec3c.png";